import React, { useEffect, useState } from "react";
import Header from "../repeat/Header";
import Leftnavigation from "./Leftnavigation";
import Footer from "../repeat/Footer";
import "../admin/style/hostel.css"; // Custom CSS for edit form
import { Navigate } from "react-router-dom";

const CmeDepartment = () => {
  const [data, setData] = useState([]);
  const [editIndex, setEditIndex] = useState(null); // Keeps track of which card is being edited
  const [editedFields, setEditedFields] = useState({}); // Tracks changes in fields
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    } else {
      setUsername(null);
    }
    setIsLoading(false);

    const fetchData = async () => {
      try {
        const response = await fetch("https://gptkpm.in/backend/admin/hostel.php");
        if (!response.ok) {
          throw new Error("Failed to fetch data.");
        }
        const fetchedData = await response.json();
        setData(fetchedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditedFields({});
  };

  const handleCancel = () => {
    setEditIndex(null);
    setEditedFields({});
  };

  const handleInputChange = (field, value) => {
    setEditedFields((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (file) => {
    setEditedFields((prev) => ({ ...prev, image: file }));
  };

  const handleSubmit = async (id) => {
    const formData = new FormData();
    formData.append("id", id);

    if (editedFields.name) formData.append("name", editedFields.name);
    if (editedFields.profession) formData.append("profession", editedFields.profession);
    if (editedFields.email) formData.append("email", editedFields.email);
    if (editedFields.phone_number) formData.append("phone_number", editedFields.phone_number);
    if (editedFields.image) formData.append("image", editedFields.image);

    try {
      const response = await fetch("https://gptkpm.in/backend/admin/hostel.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.success) {
        alert("Record updated successfully!");

        setData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? {
                  ...item,
                  ...(editedFields.name && { name: editedFields.name }),
                  ...(editedFields.profession && { profession: editedFields.profession }),
                  ...(editedFields.email && { email: editedFields.email }),
                  ...(editedFields.phone_number && { phone_number: editedFields.phone_number }),
                  ...(editedFields.image && { image: URL.createObjectURL(editedFields.image) }),
                }
              : item
          )
        );

        setEditIndex(null);
        setEditedFields({});
      } else {
        alert("Failed to update record.");
      }
    } catch (error) {
      console.error("Error updating record:", error);
      alert("An error occurred while updating.");
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!username) {
    return <Navigate to="/Admin" />;
  }

  return (
    <div className="container">
      <Header />
      <Leftnavigation />
      <div className="main-content">
        <h2 className="title-1">Hostel Data Update</h2>
        <div className="cards-container">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="card-list">
              {data.map((item, index) => (
                <div key={item.id} className="cardd">
                  <div style={{width:"100%"}}>
                  <div
                    className="card-image"
                    style={{ backgroundImage: `url(${item.image})` }}
                  ></div>
                  <div className="card-details">
                    <h3>Name:{item.name}</h3>
                    <p><strong>Profession:</strong> {item.profession}</p>
                    <p><strong>Email:</strong> {item.email}</p>
                    <p><strong>Phone:</strong> {item.phone_number}</p>
                  </div>
                  <button className="edit-btn" onClick={() => handleEdit(index)}>Edit</button>
                  </div>
                  {/* Inline Edit Form */}
                  {editIndex === index && (
                    <div className="edit-form-container">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSubmit(item.id);
                        }}
                        className="edit-form"
                      >
                        <h2>Edit Details</h2>
                        <input
                          type="text"
                          defaultValue={item.name}
                          placeholder="Update Name"
                          onChange={(e) => handleInputChange("name", e.target.value)}
                        />
                        <input
                          type="text"
                          defaultValue={item.profession}
                          placeholder="Update Profession"
                          onChange={(e) => handleInputChange("profession", e.target.value)}
                        />
                        <input
                          type="email"
                          defaultValue={item.email}
                          placeholder="Update Email"
                          onChange={(e) => handleInputChange("email", e.target.value)}
                        />
                        <input
                          type="tel"
                          defaultValue={item.phone_number}
                          placeholder="Update Phone Number"
                          onChange={(e) => handleInputChange("phone_number", e.target.value)}
                        />
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleFileChange(e.target.files[0])}
                        />
                        <button type="submit" className="save-btn">
                          Save
                        </button>
                        <button type="button" className="cancel-btn" onClick={handleCancel}>
                          Cancel
                        </button>
                      </form>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CmeDepartment;
